import { BaseChartAPIProps } from '@chart/types/create.types';

import { ChartStoreReturn } from '../create/chart-store/chartStore';
import { reDraw } from '../create/redraw/redraw';
import { dispatchPriceHoverEvent } from '../events/events';

export const onMouseLeave = (chartStore: ChartStoreReturn) => {
  const base = chartStore.getState().base as BaseChartAPIProps;
  dispatchPriceHoverEvent({
    base,
    priceHover: undefined,
  });
  reDraw({ chartStore });
};
